import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import PageLayout from '@BUP/components/Layout/Page'
import { useState } from 'react'
import { HelpDrawer } from '@BUP/components/Generics/help-drawer.jsx'
import { PageHeaderWithHelpIcon } from '@BUP/components/Generics/page-header-with-help-icon.jsx'
import { ComplaintsSection } from '@BUP/components/complaint/section'
import { FilteredComplaintsContextProvider } from '@BUP/contexts/filtered-complaints-context'
import { useGetComplaints } from '@BUP/hooks/Logbook/useGetComplaints'

export const LogbookPage = () => {
  const i18n = useTranslation()
  const [open, setOpen] = useState(false)
  const showDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)
  const { complaints, isLoading, error, mutate } = useGetComplaints()

  return (
    <PageLayout>
      <FilteredComplaintsContextProvider complaints={complaints}>
        <PageHeaderWithHelpIcon title={i18n.t('pages.logbook.title')} titleLevel={1} iconOnClick={showDrawer} />
        {i18n.t('pages.logbook.description', { returnObjects: true }).map((text, index) => <Typography.Paragraph type='secondary' key={index}>{text}</Typography.Paragraph>)}
        <ComplaintsSection complaints={complaints} mutate={mutate} error={error} isLoading={isLoading} />
        <HelpDrawer prefix='pages.logbook' title={i18n.t('pages.logbook.title')} open={open} onClose={closeDrawer} />
      </FilteredComplaintsContextProvider>
    </PageLayout>
  )
}
